import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { buildUserForm } from './user-form-builder';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AddUser } from '@dwo/actions';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  standalone: false,
})
export class AddUserComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddUserComponent>,
    private store: Store,
    private router: Router,
  ) {
    this.form = buildUserForm(formBuilder);
  }

  ngOnInit() {}

  async onAdd() {
    const formValue = this.form.getRawValue();

    const user = {
      username: formValue.username?.trim().toLowerCase() ?? '',
      name: formValue.fullName,
      sapId: formValue.sapId,
    };

    this.store.dispatch(new AddUser(user as any));

    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
